<template>
  <div class="question-part">

    <div class="card">
      <div class="card-body">
        <b-button v-b-modal.chapterselect variant="dark" size="sm" class="mb-3 py-0 px-2">
          <span class="font-weight-bold">章節選擇</span>
        </b-button>

        <h2>謎題</h2>
        <hr/>
        <slot></slot>

        <div class="answer" v-if="!customAnswer">
          <input type="text" class="form-control" placeholder="請輸入答案" v-model="inputAnswer" />
          <div class="row justify-content-center mt-2">
            <div class="col col-lg-4">
              <button class="btn btn-danger btn-block" @click="sendAnswer">確定</button>
            </div>
            <div class="col-auto" v-if="hasHint">
              <b-button v-b-modal.hint variant="light">
                <span>
                  <font-awesome-icon :icon="['fa', 'lightbulb']" fixed-width/>
                  提示
                </span>
              </b-button>
            </div>
          </div>
        </div>

        <div class="answer" v-if="customAnswer">
          <div class="row justify-content-center mt-2">
            <div class="col-12 text-center" v-if="hasHint">
              <b-button v-b-modal.hint variant="light">
                <span>
                  <font-awesome-icon :icon="['fa', 'lightbulb']" fixed-width/>
                  提示
                </span>
              </b-button>
            </div>
          </div>
        </div>

      </div>
    </div>

    <b-modal id="hint" hide-footer title="提示" v-if="hasHint">
      <div>
        <p>{{hint}}</p>

        <div class="text-center" v-if="hasMoreHint">
          <b-button v-b-modal.morehint variant="secondary">
            <span>
              <font-awesome-icon :icon="['fa', 'lightbulb']" fixed-width/>
              更多提示
            </span>
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal id="morehint" hide-footer title="進階提示" v-if="hasMoreHint">
      <div>
        <p>{{morehint}}</p>
      </div>
    </b-modal>

  </div>
</template>

<script>
export default {
  name: 'question-part',
  props: {
    hint: {
      type: String,
      required: false,
      default: '',
    },
    morehint: {
      type: String,
      required: false,
      default: '',
    },
    customAnswer: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data() {
    return {
      inputAnswer: '',
    }
  },
  computed: {
    hasHint() {
      return this.hint.length > 0;
    },
    hasMoreHint() {
      return this.morehint.length > 0;
    },
  },
  methods: {
    sendAnswer() {
      const u = this.inputAnswer.trim();
      if (u.length > 0) {
        window.location.href = `./${u}`;
      } else {
        alert('答案請至少輸入一個字!');
      }
    }
  }
}
</script>

<style scoped>

.question-part{

}

.question-part .card{
  background-color: #e8d790;
  background-image: url("data:image/svg+xml,%3Csvg width='80' height='88' viewBox='0 0 80 88' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M22 21.91V26h-2c-9.94 0-18 8.06-18 18 0 9.943 8.058 18 18 18h2v4.09c8.012.722 14.785 5.738 18 12.73 3.212-6.99 9.983-12.008 18-12.73V62h2c9.94 0 18-8.06 18-18 0-9.943-8.058-18-18-18h-2v-4.09c-8.012-.722-14.785-5.738-18-12.73-3.212 6.99-9.983 12.008-18 12.73zM54 58v4.696c-5.574 1.316-10.455 4.428-14 8.69-3.545-4.262-8.426-7.374-14-8.69V58h-5.993C12.27 58 6 51.734 6 44c0-7.732 6.275-14 14.007-14H26v-4.696c5.574-1.316 10.455-4.428 14-8.69 3.545 4.262 8.426 7.374 14 8.69V30h5.993C67.73 30 74 36.266 74 44c0 7.732-6.275 14-14.007 14H54zM42 88c0-9.94 8.06-18 18-18h2v-4.09c8.016-.722 14.787-5.738 18-12.73v7.434c-3.545 4.262-8.426 7.374-14 8.69V74h-5.993C52.275 74 46 80.268 46 88h-4zm-4 0c0-9.943-8.058-18-18-18h-2v-4.09c-8.012-.722-14.785-5.738-18-12.73v7.434c3.545 4.262 8.426 7.374 14 8.69V74h5.993C27.73 74 34 80.266 34 88h4zm4-88c0 9.943 8.058 18 18 18h2v4.09c8.012.722 14.785 5.738 18 12.73v-7.434c-3.545-4.262-8.426-7.374-14-8.69V14h-5.993C52.27 14 46 7.734 46 0h-4zM0 34.82c3.213-6.992 9.984-12.008 18-12.73V18h2c9.94 0 18-8.06 18-18h-4c0 7.732-6.275 14-14.007 14H14v4.696c-5.574 1.316-10.455 4.428-14 8.69v7.433z' fill='%23fae7b3' fill-opacity='0.46' fill-rule='evenodd'/%3E%3C/svg%3E");
  border-radius: 0px;
  border: none;
  box-shadow: 0px 0px 6px #444;
}

.question-part .card-body{

}

.question-part h2 {
  text-align: center;
  font-weight: 1000;
  color: #8c6701;
}

.question-part hr {
  border-color: #8c6701;
}

.question-part p{

}

.question-part .answer {

}

.question-part .answer .btn {

}

@media (min-width: 768px){

  .question-part .card{
    margin: 0 auto;
    max-width: 500px;
  }

}

</style>
